import {useState} from 'react'
import {useIntl} from 'react-intl'
import {useParams} from 'react-router-dom'
import {appsAPI} from '../../../../../../services/AppsService'
import {AmoCRMUsersInService} from './AmoCRMUsersInService'

const AmoCRMUsers = () => {
  const intl = useIntl()
  const {appId} = useParams()
  const [syncUsers, {isLoading: isSyncing}] = appsAPI.useSyncAmoCRMUsersMutation()
  const [syncNotice, setSyncNotice] = useState<{type: 'success' | 'danger'; text: string} | null>(null)

  const handleSync = async () => {
    setSyncNotice(null)
    try {
      const result = await syncUsers(appId!).unwrap()
      setSyncNotice({
        type: 'success',
        text: intl.formatMessage({id: 'APPS.SETTINGS.AMOCRM.USERS.SYNC.SUCCESS'}, {...result}),
      })
    } catch (err: any) {
      const detail = err?.data?.detail
      setSyncNotice({
        type: 'danger',
        text:
          typeof detail === 'string' && detail
            ? detail
            : intl.formatMessage({id: 'APPS.SETTINGS.AMOCRM.USERS.SYNC.ERROR'}),
      })
    }
  }

  return (
    <div className='card card-custom card-stretch shadow-sm mb-5'>
      <div className='card-header mt-5'>
        <div className='d-flex flex-stack col-12'>
          <div className='card-title m-0 d-flex flex-wrap'>
            <h3 className='fw-bolder m-0'>{intl.formatMessage({id: 'ASIDE.MENU.MANAGEMENT.ITEM.USERS'})}</h3>
          </div>
          <button className='btn btn-sm btn-primary align-self-center' disabled={isSyncing} onClick={handleSync}>
            {!isSyncing && (
              <>
                <i className='fas fa-sync-alt fs-5 me-1'></i>
                {intl.formatMessage({id: 'APPS.SETTINGS.AMOCRM.USERS.SYNC'})}
              </>
            )}
            {isSyncing && (
              <span className='indicator-progress' style={{display: 'block'}}>
                {intl.formatMessage({id: 'WAIT'})}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
        <div className='d-flex row col-12 mb-5 mt-5 fs-8'>
          <div className='col-2 col-lg-12 col-sm-12'>
            <span className='small text-uppercase fw-bolder text-gray-600'>
              {intl.formatMessage({id: 'APPS.SETTINGS.USERS.AA'})}
            </span>
            <span className='small text-gray-600'> - {intl.formatMessage({id: 'APPS.SETTINGS.USERS.AA.LABEL'})}</span>
          </div>
          <div className='col-10 col-lg-12 col-sm-12'>
            <span className='small text-uppercase fw-bolder text-gray-600'>
              {intl.formatMessage({id: 'APPS.SETTINGS.USERS.MR'})}
            </span>
            <span className='small text-gray-600'> - {intl.formatMessage({id: 'APPS.SETTINGS.USERS.MR.LABEL'})}</span>
          </div>
        </div>
      </div>
      <div className='card-body px-2'>
        {syncNotice && (
          <div
            className={`alert alert-dismissible d-flex align-items-center p-4 mb-6 ${
              syncNotice.type === 'success' ? 'alert-success' : 'alert-danger'
            }`}
          >
            <div className='d-flex flex-column'>
              <span>{syncNotice.text}</span>
            </div>
            <button
              type='button'
              className='btn-close ms-auto'
              aria-label='Close'
              onClick={() => setSyncNotice(null)}
            ></button>
          </div>
        )}
        <div className='table-responsive'>{<AmoCRMUsersInService />}</div>
      </div>
    </div>
  )
}

export {AmoCRMUsers}
